import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { apiSlice } from '../apiSlice';
import { Template } from './programModels';

export const selectProgramRaw = (state: RootState) => apiSlice.endpoints.getProgram.select()(state);

export const selectProgramLoaded = createSelector(
  [selectProgramRaw],
  (slice) => slice.status === 'fulfilled'
);

export const selectProgramLoading = createSelector(
  [selectProgramRaw],
  (slice) =>  slice.isLoading
);

export const selectProgramStatus = createSelector(
  [selectProgramRaw],
  (slice) =>  slice.status
);

export const selectProgram = createSelector(
  [selectProgramRaw],
  (slice) =>  slice.data
);

export const selectProgramId = createSelector(
  [selectProgram],
  (program) =>  program?.id || ''
);

export const selectProgramName = createSelector(
  [selectProgram],
  (program) =>  program?.programName || "Public"
);

export const selectProgramDomainKey = createSelector(
  [selectProgram],
  (program) =>  program?.domainKey || "default-domain-key"
);

export const selectProgramTemplate = createSelector(
  [selectProgram],
  (program) =>  program ? JSON.parse(program.templateJson) : {} as Template
);

export const selectProgramResourceStrings = createSelector(
  [selectProgram],
  (program) =>  program?.resourceStrings || null
);

export const selectFieldMappingRaw = (state: RootState) => apiSlice.endpoints.getFieldMapping.select('')(state);

export const selectFieldMapping = createSelector(
  [selectFieldMappingRaw],
  (slice) => slice.data
);

export const selectFieldMappingLoading = createSelector(
  [selectFieldMappingRaw],
  (slice) => slice.isLoading
);
